import * as Yup from "yup";

export const tourValidationSchema = Yup.object().shape({
  basicInfo: Yup.object().shape({
    tour_name: Yup.string().required("Tour name is required"),
    description: Yup.string().required("Tour description is required"),
    country: Yup.string().required("Country is required"),
    state: Yup.string(),
    city: Yup.string(),
    duration: Yup.string().required("Duration is required"),
    tour_type: Yup.string(),
  }),

  itinerary: Yup.array()
    .of(
      Yup.object().shape({
        day: Yup.string(),
        title: Yup.string(),
        description: Yup.string(),
        location: Yup.string(),
        startTime: Yup.string(),
        endTime: Yup.string(),
      })
    )
    .min(1, "At least one day is required")
    .required("Itinerary is required"),

  pricing: Yup.object().shape({
    pricePerPerson: Yup.number()
      .typeError("Price must be a number")
      .required("Price per person is required")
      .min(0, "Price cannot be negative"),
    currency: Yup.string().required("Currency is required"),
    discount: Yup.object()
      .nullable()
      .shape({
        discountValue: Yup.number()
          .typeError("Discount must be a number")
          .positive("Discount must be greater than zero"),
        minGroupSize: Yup.number()
          .typeError("Minimum group size must be a number")
          .integer("Group size must be a whole number")
          .min(1, "Minimum group size must be at least 1"),
      }),
  }),

  availability: Yup.array()
    .of(
      Yup.object().shape({
        startDate: Yup.string().required("Start date is required"),
        endDate: Yup.string().required("End date is required"),
        minGuests: Yup.number()
          .typeError("Min guests must be a number")
          .required("Minimum guests is required")
          .integer("Must be a whole number")
          .min(1, "Must be at least 1"),
        maxGuests: Yup.number().typeError("Max guests must be a number"),
        isAvailable: Yup.boolean(),
      })
    )
    .min(1, "At least one availability period is required")
    .required("Availability is required"),

  additional: Yup.object().shape({
    requirements: Yup.string(),
    cancellationPolicy: Yup.string().required("Cancellation policy is required"),
    contact: Yup.object().shape({
      name: Yup.string(),
      phone: Yup.string().matches(
        /^[\d+()\s-]{7,20}$/,
        "Phone number is not valid"
      ),
      email: Yup.string().email("Invalid email"),
    }),
    tags: Yup.array().of(Yup.string()),
  }),

  media: Yup.object().shape({
    tourImages: Yup.array()
      .of(Yup.string().url("Invalid image URL"))
      .min(1, "At least one tour image is required"),
    tourVideos: Yup.array().of(Yup.string().url("Invalid video URL")),
    additionalFiles: Yup.array().of(Yup.string().url("Invalid file URL")),
  }),
});
